module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-test-yourself.39974491.png";